//
//  SDKDocumentationLegacyItemType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyItemType;
(function (DocumentationLegacyItemType) {
    DocumentationLegacyItemType["group"] = "Group";
    DocumentationLegacyItemType["page"] = "Page";
})(DocumentationLegacyItemType || (DocumentationLegacyItemType = {}));
